import styled, { css } from 'styled-components'
import AppLinkMobileCtrl from 'Components/AppLinkMobileCtrl'
import { NoMarginRow, TileCol } from 'Components/EnhacedFlexboxGrid'
import SectionSeparatorLine from 'Components/SectionSeparatorLine'
import { BREAK_POINT_MD, BREAK_POINT_LG } from '@CSSVars/variables'
import {
  SECONDARY_LIGHTEST_COLOR, TEXT_GREY,
  SECONDARY_NORMAL_COLOR, GREY_LIGHTER_COLOR, CLICKABLE_COLOR, LINK_COLOR,
  GREY_BACKGROUND, OUTLINE_COLOR, SITE_BLACK_COLOR, SELECTED_ITEM_BG_COLOR,
} from '@CSSVars/colors'
import ChartSummaryBlock from './ChartSummaryBlock'


export const simpleChartCollapseContentCss = css`
  margin-top: 6px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 16px;
  }
`

export const printCollapsibleContentCss = css`
  margin-top: 12px;
`

export const maintChartCollapseContentCss = css`
  margin-top: 24px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-top: 20px;
  }
`

export const _RowContainer = styled.div`
  display: flex;

  @media screen and (max-width: 1279px) {
    display: block;
  }
`

export const _AreaOfferContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: start;
  width: 100%;

  @media screen and (min-width: ${BREAK_POINT_MD}) {
    margin-bottom: 12px;
    > div {
      margin-bottom: 0;
    }
  }
`
export const _OfferContainer = styled.div`
  margin-left: 90px;
  margin-bottom: 12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    margin-left: 0px;
  }
`


export const _RangeSliderPositionContainer = styled.div`
  position: absolute;
  right: 0;
  display: block;
  @media screen and (max-width: 1160px) {
    display: none;
  }
`

export const _RangeSliderContainer = styled.div`
  color: ${SECONDARY_LIGHTEST_COLOR};
  overflow: visible;
  border: 1px solid ${OUTLINE_COLOR};
  padding: 0 10px;
  border-radius: 10px;

  .handle-0, .handle-1 {
      border: 1px solid ${OUTLINE_COLOR} !important;
      background: white !important;
      color: ${SITE_BLACK_COLOR} !important;
    }
  .bar{
    height: 2px;
    background-color: ${OUTLINE_COLOR} !important;
    top: -2px;
  }
  .bar-1{
    background-color: ${SITE_BLACK_COLOR} !important;
  }


  label {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    height: 44px;
  }
  @media screen and (max-width: ${BREAK_POINT_LG}) {
    display: none;
    height: 0;
  }
`

export const _DesktopVisitButtonContainer = styled.div`
  width: 100%;
  line-height: 22px;
  display: inline-block;
  margin-bottom: 12px!important;

  @media screen and (max-width: 1160px) {
    width: auto;
  }

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: none;
  }
`

export const _MobileVisitButtonContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  text-align: start;
  display: none;
  line-height: 22px;

  @media screen and (max-width: ${BREAK_POINT_MD}) {
    display: block;
  }
`

export const _VisitButton = styled(AppLinkMobileCtrl)`
  text-decoration: underline;
  cursor: pointer;
  color: ${CLICKABLE_COLOR};
  @media (hover: hover){
    &:hover{
      color:${LINK_COLOR};
    }
  }
  &:active{
    color: ${SELECTED_ITEM_BG_COLOR};
  }
`

export const _ChartWrapper = styled.div`
    display: block;
`

export const _SummaryContainer = styled.div`
  flex-shrink: 0;
  width: 100%;
  margin: ${({ isPrintStyle }) => (isPrintStyle ? '0 0 8px 0!important' : '0 0 8px 0')};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 24px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    flex-direction: column;
  }

`

export const _ChartSummaryBlock = styled(ChartSummaryBlock)`
    margin-bottom: 0;
    display: inline-block;
    width: 49%;
    background: ${GREY_BACKGROUND};
    padding: 13px 17px 16px;
    border-radius: 10px;
    border-left: none;

  &:nth-child {
    width: 49%;
    margin-left: ${({ printStyle }) => (printStyle ? '85px' : '0')};
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    width: 100%;
    margin-top: 12px;
  }
`

export const _AdditionalFees = styled(NoMarginRow)`
  margin-top: ${({ isPrintStyle }) => (isPrintStyle ? '0' : '20px')};
  padding-right: ${({ isPrintStyle }) => (isPrintStyle ? '16' : '0')}px;
  justify-content: space-between;

  > div {
    display: flex;
    width: 50%;
    flex-basis: 50%;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    > div {
      width: 100%;
      flex-basis: 100%;
    }
  }
`

export const _InsightCard = styled(TileCol)`
  max-width: 50%;
  flex-basis: 50%;

  @media screen and (max-width: ${BREAK_POINT_LG}) {
    max-width: 100%;
    flex-basis: 100%;
    margin-bottom: 10px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    padding: 0;
    margin-bottom: 0;
    &:first-child {
      margin-top: 64px;
      margin-bottom: 12px;
    }
  }
`

// ////////////////////////////////////////////////////////////////////////////
// // Custom Classes //////////////////////////////////////////////////////////

export const collapseContainerCss = css`
  margin-top: 24px;

  @media screen and (max-width: 767px) {
    margin-top: 16px;
  }
`

export const outerCollapseLabelCss = css`
  font-size: 20px !important;
  line-height: 20px !important;

  @media screen and (max-width: 1024px) {
    h3 {
      display: block;
      margin-left: 0;
      line-height: 22px;
    }
  }
  @media screen and (max-width: 767px) {
    font-size: 16px !important;
    line-height: 20px !important;
  }
`

export const sliderCollapseLabelCss = css`
  min-width: 160px;
  height: 32px;

  display: flex !important;
  font-size: 12px !important;
  line-height: 1;
  white-space: nowrap;
  color: ${SITE_BLACK_COLOR};
  justify-content: center;
  align-items: center;
  border-radius: 0;

  svg {
    margin-top: 1px;
    margin-left: 2px;
  }
`

export const sliderCollapseContentCss = css`
  position: absolute;
  width: 250px;
  right: 0;
  top: 46px;
  z-index: 10;

  background: white;
  margin-top: 0;
  box-shadow: 0 0 12px rgba(128, 128, 128, 0.3);
  opacity: 0;

  .sliderHandle {
    background: white;
    color: ${SECONDARY_NORMAL_COLOR};
    box-shadow: 0 3px 10px 0 rgba(128, 128, 128, 0.7);
  }

  .bar {
    background-color: ${GREY_LIGHTER_COLOR};
  }
  .bar-1 {
    background-color: ${CLICKABLE_COLOR};
  }

  input {
    background-color: ${GREY_BACKGROUND};
    color: ${TEXT_GREY};
  }

  label {
    color: ${TEXT_GREY};
  }
`

export const sliderCollapseInputCss = css`
  display: none;
  + label {
    pointer-events: auto;
    cursor: pointer;
  }

  &:checked + label {
    .triangle {
      transform: rotate(180deg);
    }
    + div {
      opacity: 1;
      border-radius: 10px;
    }
  }
`

export const sliderContentInnerCss = css`
  padding: 1.5rem 1.5rem 2rem 1.5rem;


  > div {
    max-width: 300px;
  }
`

export const _ChartSeparatorLine = styled(SectionSeparatorLine)`
  margin: 16px 0;
  background: transparent;
`
